export default __webpack_public_path__ + "static/media/grid-col-2.e461d803.svg";